import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import type { DashboardWidget } from './dashboardWidgetTypes';
import { DEFAULT_DASHBOARD_WIDGET_SIZE } from './dashboardConstants';

export const DashboardMissingWidget: DashboardWidget<any> = Object.assign(
  () => {
    const { t } = useTranslation();

    return (
      <Alert
        type="error"
        showIcon
        message={t('dashboards.widgets.missing.title')}
        description={t('dashboards.widgets.missing.description')}
      />
    );
  },
  {
    uid: 'missing',
    title: { t: 'dashboards.widgets.missing.title' },
    description: { t: 'dashboards.widgets.missing.description' },
    defaultSize: DEFAULT_DASHBOARD_WIDGET_SIZE,
  },
);
